A page of webhook subscriptions matching the specified criteria.

A maximum of 100 webhook subscriptions can be returned in a single page.
Additional webhook subscriptions can be queried using a pagination cursor.

The result list is returned in ascending creation date & time order.
It starts from the earliest known subscription if no pagination arguments are provided.
